import galleryHtml from './gallery.component.html';
import './gallery.component.scss';
import GalleryImage from "./galleryImage.class";
import GalleryThumbnail from "./galleryThumbnail.class";

class GalleryController {
    constructor($scope, $timeout, $window, $sce, $http) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$sce = $sce;
        this.$http = $http;
        this.limit = 5;
        this.showFull = false;
        this.supportsMatchMedia = this.$window.matchMedia !== undefined && !!this.$window.matchMedia('all').addListener;
        this.handleKeyboardEvent = ($event) => {
            this.handleKeyboard($event);
            this.$scope.$apply();
        };
        this.thumbnailsRange = {
            from: 0,
            to: 5
        }
        this.zoomEnabled = false;
        this.youtube = false;
        this.images = [];
        this.images2 = [];
        this.images2List = null;
        this.thumbnails2List = null;
        this.galleryPosition = 0;
        this.thumbnailsPosition = 0;
        this.thumbnails2 = null;
        this.currentIndex = null;
        this.dragging = false;
        this.zoomDragging = false;
        this.dragStartPosition = null;
        this.galleryPositionDelta = 0;
        this.previewWidth = 0;
        this.thumbnailsDesktopDisplay = 0;
        this.index = 0;
    }

    get thumbnails() {
        return this.images.slice(this.thumbnailsRange.from, this.thumbnailsRange.to).map(url => {
            let ytCheck = this.checkYoutubeHash(url);

            if (ytCheck) {
                return 'https://img.youtube.com/vi/' + ytCheck + '/0.jpg';
            }

            return url;
        });
    }

    get preparedImages() {
        return this.images.map(url => {
            let ytCheck = this.checkYoutubeHash(url);

            if (ytCheck) {
                return 'https://img.youtube.com/vi/' + ytCheck + '/0.jpg';
            }

            return url;
        });
    }

    prepareImages2List() {
        if (!this.images2List) {
            this.images2List = this.imagesList.map(image => new GalleryImage(image));
            this.thumbnails2List = this.imagesList.map(image => new GalleryThumbnail(image.url, image.variant_id));
        }
    }

    $onInit() {
        if (!this.thumbnailsDisplay) {
            this.thumbnailsDisplay = 5;
        }

        if (this.fullscreen) {
            this.$scope.$on('closeFullscreen', () => {
                this.triggerOnCloseEvent();
            });
        }

        this.$timeout(() => {
            this.limit = Number.MAX_SAFE_INTEGER;
        }, 5000);

        this.$scope.clickOutside = () => {
            if (!this.showFull) return;

            this.showFull = false;
            this.$scope.$apply();
        };

        angular.element(this.$window).bind('keydown', this.handleKeyboardEvent);

        angular.element(this.$window).bind('resize', () => {
            this.setThumbnailsInRowNumber(() => {
                this.$scope.$apply();
            });
        });

        this.setThumbnailsInRowNumber();
        this.setCurrent(this.current, null, true);
    }

    $onDestroy() {
        angular.element(this.$window).unbind('keydown', this.handleKeyboardEvent);
    }

    $onChanges(changesObj) {

        this.prepareImages2List();
        let duplicateFiles = [];

        // Remove duplicate files
        const currentFileId = this.images2List.find(image => image.data.url === this.current).data.file_id;

        let variantImages = [];
        let productImages = [];

        if(this.variantId) {
            variantImages = this.images2List.filter(image => {
                if (duplicateFiles[image.data.file_id] || image.data.variant_id !== parseInt(this.variantId)) {
                    return false;
                }
                duplicateFiles[image.data.file_id] = true;
                return true;
            });
        }

        productImages = this.images2List.filter(image => {
            if (duplicateFiles[image.data.file_id] || image.data.variant_id) {
                return false;
            }
            duplicateFiles[image.data.file_id] = true;
            return true;
        });

        this.images2 = variantImages.concat(productImages);

        this.thumbnails2 = this.images2.map(image => {
            return this.thumbnails2List.find(thumbnail => image.data.url === thumbnail.originalUrl);
        });

        this.setCurrent(this.current, null, true);

        const index = this.index;

        if (index > this.thumbnailsRange.from && index < this.thumbnailsRange.to - 1) return;
    }

    handleKeyboard($event) {

        if ($event.which === 90) { //z
            if(this.zoomEnabled) {
                this.disableZoom();
            } else {
                this.enableZoom();
            }
            this.$scope.$apply();
        }

        if (!this.fullscreen) {
            return;
        }

        $event.stopPropagation();
        $event.preventDefault();

        switch ($event.which) {
            case 27:
                this.triggerOnCloseEvent();
                break;
            case 37:
                this.prev();
                break;
            case 39:
                this.next();
                break;
        }
    }

    closeChildFull($event) {
        if ($event.target.classList.contains('gallery-container') || $event.target.classList.contains('gallery-thumbnails-bar')) {
            this.$scope.$broadcast('closeFullscreen');
        }
    }

    closeFull($event = null) {
        if ($event) $event.stopPropagation();
        this.showFull = false;
    }

    triggerOnCloseEvent() {
        if (this.onClose && typeof (this.onClose) === 'function') {
            this.onClose({imageUrl: this.current});
        }
    }

    openFull($event = null) {
        if (this.zoomEnabled) {
            return;
        }
        if ($event) $event.srcEvent.stopPropagation();

        this.showFull = true;
    }

    onCloseEvent(url) {
        this.closeFull();
        if (url) {
            this.setCurrent(url);
        }
    }

    setCurrent(url, $event = null, centerThumbnails = false) {
        if ($event) $event.stopPropagation();

        this.disableZoom();
        this.youtube = this.checkYoutubeHash(url);
        this.current = url;
        this.galleryPositionDelta = 0;

        let previousIndex = this.currentIndex;

        this.images2.forEach((image, index) => {
            if (this.current === image.data.url) {
                this.index = this.currentIndex = index;
                image.loadSource(() => {
                    this.$scope.$apply();
                });
            }
        });

        if (centerThumbnails) {
            this.thumbnailsCenterToCurrent();
        } else {
            let direction = 0;

            if (previousIndex !== null && this.currentIndex > previousIndex) {
                direction = 1;
            } else if (previousIndex !== null && this.currentIndex < previousIndex) {
                direction = -1;
            }

            if (direction === 1) {
                this.thumbnailsForward();
            }

            if (direction === -1) {
                this.thumbnailsRewind();
            }
        }

        if (!this.change || typeof this.change != 'function') return;

        this.change({imageUrl: url});
    }

    setThumbnailsInRowNumber(onThumbnailsInRowChanged) {
        if (this.$window.innerWidth <= 600 && this.thumbnailsDisplay > 3) {
            this.thumbnailsDesktopDisplay = this.thumbnailsDisplay;
            this.thumbnailsDisplay = 3;
            if (onThumbnailsInRowChanged) {
                onThumbnailsInRowChanged();
            }
        } else if (this.$window.innerWidth > 600 && this.thumbnailsDesktopDisplay > this.thumbnailsDisplay) {
            this.thumbnailsDisplay = this.thumbnailsDesktopDisplay;
            if (onThumbnailsInRowChanged) {
                onThumbnailsInRowChanged();
            }
        }
    }

    get galleryPositionOffset() {
        return 'calc(' + (-(this.currentIndex * 100)) + '% - ' + ((this.currentIndex + 1) * 10) + 'px + ' + this.galleryPositionDelta + 'px)';
    }

    get thumbnailsPositionOffset() {
        if (this.centeredThumbnails) {
            return '0';
        }
        return (-(100 / this.thumbnailsDisplay) * this.thumbnailsPosition) + '%';
    }

    get isNextElement() {
        return !!this.images2[this.currentIndex + 1];
    }

    get isPrevElement() {
        return !!this.images2[this.currentIndex - 1];
    }

    get centeredThumbnails() {
        return this.images2.length < this.thumbnailsDisplay;
    }

    thumbnailsCenterToCurrent() {
        if (!this.thumbnailsDisplay) {
            return;
        }
        let thumbnailsMargin = Math.ceil((this.thumbnailsDisplay - 1) / 2);

        if (this.currentIndex - thumbnailsMargin < 0) {
            this.thumbnailsPosition = 0;
        } else if (this.currentIndex + thumbnailsMargin >= this.thumbnails2.length) {
            this.thumbnailsPosition = this.thumbnails2.length - this.thumbnailsDisplay;
            if (this.thumbnailsPosition < 0) {
                this.thumbnailsPosition = 0;
            }
        } else {
            this.thumbnailsPosition = this.currentIndex - thumbnailsMargin;
        }
    }

    thumbnailsForward() {
        if (this.currentIndex - this.thumbnailsPosition === this.thumbnailsDisplay - 1) {
            if ((this.thumbnailsPosition + this.thumbnailsDisplay - 1) >= (this.thumbnails2.length - 1)) {
                this.thumbnailsPosition = this.thumbnails2.length - this.thumbnailsDisplay;
            } else {
                this.thumbnailsPosition += this.thumbnailsDisplay - 1;
            }
        }
    }

    thumbnailsRewind() {
        if (this.currentIndex === this.thumbnailsPosition) {
            if (this.thumbnailsPosition - this.thumbnailsDisplay + 1 < 0) {
                this.thumbnailsPosition = 0;
            } else {
                this.thumbnailsPosition -= this.thumbnailsDisplay - 1;
            }
        }
    }

    next($event = null) {
        if ($event && $event.stopPropagation) $event.stopPropagation();
        const index = this.index;

        if (index + 1 >= this.images2.length) {
            this.setCurrent(this.images2[0].data.url);
        } else {
            this.setCurrent(this.images2[index + 1].data.url);
        }
    }

    prev($event = null) {
        if ($event && $event.stopPropagation) $event.stopPropagation();
        const index = this.index;

        if (index <= 0) {
            this.setCurrent(this.images2[this.images2.length - 1].data.url);
        } else {
            this.setCurrent(this.images2[index - 1].data.url);
        }
    }

    enableZoom($event) {
        this.zoomEnabled = true;
    }

    disableZoom($event) {
        this.zoomEnabled = false;
        this.zoomPosition = '50%';
        this.zoomDragStartPosition = null;
        this.zoomCurrentDelta = null;
    }

    toggleZoom($event) {
        this.zoomEnabled = !this.zoomEnabled;
    }

    startDrag(event) {
        if (this.zoomEnabled) {
            return;
        }
        this.dragging = true;
        this.dragStartPositionX = event.touches ? event.touches[0].clientX : event.pageX;
        this.dragStartGalleryPositionOffset = this.galleryPositionOffset;
    }

    drag(event) {
        if (!this.dragging || this.zoomEnabled) {
            return;
        }

        this.galleryPositionDelta = (event.touches ? event.touches[0].clientX : event.pageX) - this.dragStartPositionX;

        if (this.galleryPositionDelta < 0 && this.images2[this.currentIndex + 1]) {
            this.images2[this.currentIndex + 1].loadSource(() => {
                this.$scope.$apply();
            });
        }
        if (this.galleryPositionDelta > 0 && this.images2[this.currentIndex - 1]) {
            this.images2[this.currentIndex - 1].loadSource(() => {
                this.$scope.$apply();
            });
        }
    }

    stopDrag() {
        if (this.zoomEnabled) {
            return;
        }

        this.dragging = false;

        let threshold = window.innerWidth > 600 ? 200 : 50;

        if (this.galleryPositionDelta > threshold) {
            this.prev();
        } else if (this.galleryPositionDelta < -threshold) {
            this.next();
        } else {
            this.galleryPositionDelta = 0;
        }
    }

    zoomStartDrag(event) {
        if (!this.zoomEnabled) {
            return;
        }
        if (!this.zoomCurrentDelta) {
            this.zoomCurrentDelta = {x: 0, y: 0};
        }
        this.zoomDragging = true;
        this.zoomDragStartPosition = {x: event.center ? event.center.x : event.screenX, y: event.center ? event.center.y : event.screenY};
        console.log('zoomStartDrag', this.zoomCurrentDelta);
    }

    zoomDrag(event) {
        if (!this.zoomEnabled) {
            return;
        }
        this.zoomPosition = 'calc(50% - ' + (this.zoomCurrentDelta.x + (this.zoomDragStartPosition.x - (event.center ? event.center.x : event.screenX))) + 'px) calc(50% - ' + (this.zoomCurrentDelta.y + (this.zoomDragStartPosition.y - (event.center ? event.center.y : event.screenY))) + 'px)';
        console.log(this.zoomPosition);
    }

    zoomStopDrag(event) {
        if (!this.zoomEnabled) {
            return;
        }
        this.zoomCurrentDelta = {
            x: this.zoomCurrentDelta.x + this.zoomDragStartPosition.x - (event.center ? event.center.x : event.screenX),
            y: this.zoomCurrentDelta.y + this.zoomDragStartPosition.y - (event.center ? event.center.y : event.screenY)
        };
        console.log('zoomStopDrag', this.zoomCurrentDelta);
        this.dragging = false;
    }

    checkYoutubeHash(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);

        if (match && match[7].length == 11) {
            return match[7];
        }

        var imageCheck = /img.youtube.com\/vi\/(.*?)\//;
        var match = url.match(imageCheck);

        if (match && match[1].length == 11) {
            return match[1];
        }

        return false;
    }

    trustedUrl(url) {
        return this.$sce.trustAsResourceUrl(url);
    }

    onClose(param) {

    }
}

let galleryComponent = {
    bindings: {
        imagesList: '<',
        current: '<',
        change: '&',
        variantId: '<',
        fullscreen: '<',
        thumbnailsDisplay: '<',
        onClose: '&'
    },
    template: galleryHtml,
    controller: GalleryController
}

export default galleryComponent;
